function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// src/components/spinner.ts
import { defineStyle, defineStyleConfig } from "@chakra-ui/styled-system";
import { cssVar } from "@chakra-ui/theme-tools";
var $size = cssVar("spinner-size");
var baseStyle = defineStyle({
  width: [$size.reference],
  height: [$size.reference]
});
var sizes = {
  xs: defineStyle(_defineProperty({}, $size.variable, "sizes.3")),
  sm: defineStyle(_defineProperty({}, $size.variable, "sizes.4")),
  md: defineStyle(_defineProperty({}, $size.variable, "sizes.6")),
  lg: defineStyle(_defineProperty({}, $size.variable, "sizes.8")),
  xl: defineStyle(_defineProperty({}, $size.variable, "sizes.12"))
};
var spinnerTheme = defineStyleConfig({
  baseStyle: baseStyle,
  sizes: sizes,
  defaultProps: {
    size: "md"
  }
});
export { spinnerTheme };